/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 13.11.12, 12:43
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { FontConfigVO } from "./FontConfigVO";

import { TextFormat } from "@goodgamestudios/createjs-utilities";

export class RuntimeLoadedFontConfigVO extends FontConfigVO {
    /** GGS language code for this configuration **/
    public ggsLanguageCode: string;

    constructor(ggsLanguageCode: string) {
        super();
        this.ggsLanguageCode = ggsLanguageCode;

        this.debugColor = "0xFF0000";
    }

    /**
     * Applies a scale factor to the font size regarding a specific minimum font size (if the size gets too small).
     *
     * @param inputTextFormat
     */
    public setTextFormat(inputTextFormat: TextFormat): void {
        // No min font size or fontScale defined, ignore this hook function
        if (isNaN(this.fontSizeMinimum) || this.fontScale == 1) {
            super.setTextFormat(inputTextFormat);
            return;
        }

        // If the original font size (defined in FLA) is lower than the minimum font size: leave the original one
        if (Number(inputTextFormat.size) < this.fontSizeMinimum) {
            super.setTextFormat(inputTextFormat);
            return;
        }

        // Apply scale
        inputTextFormat.size = Number(inputTextFormat.size) * this.fontScale;

        // Check if the size drops below the minimum
        if (inputTextFormat.size < this.fontSizeMinimum) {
            inputTextFormat.size = this.fontSizeMinimum;
        }

        super.setTextFormat(inputTextFormat);
    }

    public toString(): string {
        return "ggsLanguageCode: " + this.ggsLanguageCode + ", " + super.toString();
    }
}
